import { EBulkCloseType } from '@aqx-core/common/services/mixpanel/types';
import { EOrderProfitStatus } from '@aqx-core/common/services/order/types';

export const mapOrderProfitStatusToBulkCloseType = (status: EOrderProfitStatus) => {
  switch (status) {
    case EOrderProfitStatus.PROFIT:
      return EBulkCloseType.PROFITABLE_POSITIONS;
    case EOrderProfitStatus.LOSS:
      return EBulkCloseType.LOSING_POSITIONS;
    default:
      return EBulkCloseType.ALL_POSITIONS;
  }
};
